// Lib
import { createAction } from 'redux-actions';

export const ShowToast = createAction('SHOW_TOAST');
export const HideToast = createAction('HIDE_TOAST');
